import { useEffect, useState } from 'react';

const useDeviceDetails = () => {
    const [deviceDetails, setDeviceDetails] = useState({
        userAgent: '',
        browser: '',
        os: '',
        device: '',
        manufacturer: '',
        model: '',
        channel: ''
    });

    useEffect(() => {
        const ua = navigator.userAgent;
        const platform = navigator.platform;

        // Get Browser
        const getBrowser = () => {
            if (ua.includes('Chrome') && !ua.includes('Edg')) return 'Chrome';
            if (ua.includes('Firefox')) return 'Firefox';
            if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
            if (ua.includes('Edg')) return 'Edge';
            if (ua.includes('Opera') || ua.includes('OPR')) return 'Opera';
            return 'Unknown Browser';
        };

        // Get OS - Using platform for more accurate detection
        const getOS = () => {
            if (platform.startsWith('Mac')) return 'MacOS';
            if (platform.startsWith('Win')) return 'Windows';
            if (platform.startsWith('Linux')) return 'Linux';
            if (/Android/.test(ua)) return 'Android';
            if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
            return 'Unknown OS';
        };

        // Get Device Type and isMobile flag
        const getDeviceInfo = () => {
            // Check if device is mobile based on platform and userAgent
            const isMobile = /iPhone|iPad|iPod|Android|Mobile|Tablet/i.test(ua);
            
            // Check if it's a desktop platform
            const isDesktop = /Win32|Win64|MacIntel|Linux x86_64/i.test(platform);

            if (isDesktop) {
                return { device: 'Desktop', isMobile: false };
            }
            
            if (ua.includes('Tablet') || ua.includes('iPad')) {
                return { device: 'Tablet', isMobile: true };
            }
            
            if (isMobile) {
                return { device: 'Mobile', isMobile: true };
            }

            return { device: 'Desktop', isMobile: false };
        };

        // Get Manufacturer and Model
        const getManufacturerAndModel = () => {
            if (platform.startsWith('Mac')) {
                return {
                    manufacturer: 'Apple',
                    model: 'MacBook'
                };
            }

            if (platform.startsWith('Win')) {
                return {
                    manufacturer: 'PC',
                    model: 'Windows PC'
                };
            }

            if (ua.includes('iPhone')) {
                return {
                    manufacturer: 'Apple',
                    model: 'iPhone'
                };
            }

            if (ua.includes('iPad')) {
                return {
                    manufacturer: 'Apple',
                    model: 'iPad'
                };
            }

            return {
                manufacturer: 'Unknown',
                model: 'Unknown Device'
            };
        };

        // Get Channel - Using platform for more accurate detection
        const mapToChannelEnum = (platform, isMobile) => {
            // Desktop platforms
            
            if (/iPhone|iPad|iPod/i.test(platform)) {
                return "Web IOS";
            } else if (/Android/i.test(platform)) {
                return "Web Android";
            } else if (/Win32|Win64|MacIntel|Linux x86_64/i.test(platform)) {
                return "Web Browser";
            }
            
            // Mobile platforms
            if (isMobile) {
                if (/Android/i.test(ua)) {
                    return "Android";
                }
                if (/iPhone|iPad|iPod/i.test(ua)) {
                    return "iPhone";
                }
            }
            
            return "Web Browser";
        };

        const { manufacturer, model } = getManufacturerAndModel();
        const { device, isMobile } = getDeviceInfo();
        const channel = mapToChannelEnum(platform, isMobile);

        setDeviceDetails({
            userAgent: ua,
            browser: getBrowser(),
            os: getOS(),
            device,
            manufacturer,
            model,
            channel,
            platform
        });
    }, []);

    return deviceDetails;
};

export default useDeviceDetails;
